module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_b1_dark.a03917a9.svg";